import http from './httpService';
/*global API */
const companyEndpoint = `${API}/api/company`;

export function updateCompanyEmailSettings(companyId, columnId, sendAutomatedEmail, emailSubject, emailContent) {
  return http.put(companyEndpoint + '/updateCompanyEmailSettings', {
    companyId: companyId,
    columnId: columnId,
    sendAutomatedEmail: false,
    emailContent: emailContent,
    emailSubject: emailSubject,
  });
}

export function sendVerificationRequest(message, company) {
  return http.put(companyEndpoint + '/sendVerificationRequest', {
    companyId: company.id,
    message: message,
  });
}

export function updateCompanyStatus(id, newStatus) {
  return http.put(companyEndpoint + '/updateCompanyStatus', {
    companyId: id,
    newStatus: newStatus,
  });
}
